import React from "react";
import { useState } from "react";
//import { format } from "date-fns";
import { sendFriendRequest, removeFriend, UserProfile } from "../actions/index";

interface UserProfileModalProps {
  user: UserProfile;
  currentUserId: string;
  onClose: () => void;
}

export const UserProfileModal = ({
  user,
  currentUserId,
  onClose,
}: UserProfileModalProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAction = async (action: "send" | "remove") => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const success =
        action === "send"
          ? await sendFriendRequest(currentUserId, user.userId)
          : await removeFriend(currentUserId, user.userId);

      if (success) {
        alert(action === "send" ? "Friend request sent!" : "Friend removed");
      } else {
        alert("Action failed. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const getFriendshipButton = () => {
    if (currentUserId === user.userId) return null;

    let buttonConfig = {
      text: "",
      action: () => {},
      color: "",
      hoverColor: "",
      disabled: false,
    };

    if (user.friends?.includes(currentUserId)) {
      buttonConfig = {
        text: isLoading ? "Removing..." : "Remove Friend",
        action: () => handleAction("remove"),
        color: "#ef4444",
        hoverColor: "#dc2626",
        disabled: isLoading,
      };
    } else if (user.friendRequests?.includes(currentUserId)) {
      buttonConfig = {
        text: "Request Pending",
        action: () => {},
        color: "#9ca3af",
        hoverColor: "#9ca3af",
        disabled: true,
      };
    } else {
      buttonConfig = {
        text: isLoading ? "Sending..." : "Send Friend Request",
        action: () => handleAction("send"),
        color: "#3b82f6",
        hoverColor: "#2563eb",
        disabled: isLoading,
      };
    }

    return (
      <button
        style={{
          backgroundColor: buttonConfig.disabled
            ? "#cccccc"
            : isHovered
            ? buttonConfig.hoverColor
            : buttonConfig.color,
          color: "white",
          border: "none",
          padding: "0.8rem 1.5rem",
          borderRadius: "4px",
          cursor: buttonConfig.disabled ? "not-allowed" : "pointer",
          fontSize: "1rem",
          transition: "background-color 0.2s",
        }}
        onClick={() => !buttonConfig.disabled && buttonConfig.action()}
        disabled={buttonConfig.disabled}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {buttonConfig.text}
      </button>
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "2rem",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "400px",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          &times;
        </button>

        <div style={{ textAlign: "center" }}>
          <img
            src={user.photoURL || "default-avatar.png"}
            alt={user.displayName}
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              marginBottom: "1rem",
            }}
          />
          <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.5rem" }}>
            {user.displayName}
          </h2>
          <p style={{ color: "#666", marginBottom: "1rem" }}>{user.email}</p>

          <div style={{ margin: "1rem 0", color: "#444" }}>
            <p>{/* Member since: {format(user.createdAt, 'MMM yyyy')} */}</p>
          </div>

          {getFriendshipButton()}
        </div>
      </div>
    </div>
  );
};
